<template>
    <div class="bg-transparent m-0">
        <b-dropdown
            offset="-25"
            id="dropdown"
            class="dropdown mr-2"
            variant="link"
            no-caret
            toggle-class="px-0"
        >
            <template v-slot:button-content>
                <span class="dropdown">
                    <img v-if="langName === 'En'" src="/promo/img/ukFlag.png" class="rounded-circle" alt="">
                    <img v-else-if="langName === 'Ru'" src="/promo/img/rusFlag.png" class="rounded-circle" alt="">
                    <img v-else src="/promo/img/uzbFlag.png" class="rounded-circle" alt="">
                    {{ langName }}
                    <img src="/promo/img/polygon.png" style="margin-left: 4px;" alt="">
                </span>
            </template>

            <b-dropdown-item v-bind:active="lang === 'uz'" @click="goWithLang('uz')">
                <span> <img src="/promo/img/uzbFlag.png" alt=""> Uz</span>
            </b-dropdown-item>

            <b-dropdown-item v-bind:active="lang === 'ru'" @click="goWithLang('ru')">
                <span> <img src="/promo/img/rusFlag.png" alt=""> Ru</span>
            </b-dropdown-item>

            <b-dropdown-item v-bind:active="lang === 'en'" @click="goWithLang('en')">
                <span> <img src="/promo/img/ukFlag.png" alt=""> En</span>
            </b-dropdown-item>
        </b-dropdown>
    </div>

</template>

<script>

export default {
    name: "PromoLanguageSwitcher",
    data() {
        return {
            lang: this.$i18n.locale,
        }
    },
    computed: {
        langName() {
            switch (this.lang) {
                case 'ru':
                    return "Ru"
                case 'en':
                    return "En"
                case 'uz':
                default:
                    return "Uz"
            }
        },
    },
    methods: {
        goWithLang(lang) {
            this.$router.push('/' + lang + '/' + this.$route.path.slice(4))
        },
    },
    watch: {
        '$i18n.locale': function () {
            this.lang = this.$i18n.locale
        }
    }
}

</script>

<style scoped>
b-dropdown-item.active {
    background-color: #6f42c1 !important;
}

.dropdown-item.active {
    background-color: #6f42c1 !important;
}

@media screen and (min-width: 992px) {
    .rounded-circle {
        color: #000000;
    }

    span.dropdown {
        text-decoration: none;
        color: #000000;
    }

    span.dropdown:hover {
        color: #000000;
        background-color: transparent;
    }
}

@media screen and (max-width: 992px) {
    .rounded-circle {
        height: 24px !important;
        width: 24px !important;
        margin-right: 10px !important;
        padding: 2px !important;
        background: #ffffff;
    }

    span.dropdown {
        background-color: transparent !important;
        padding: 0 !important;
        color: #ffffff;
    }

    span.dropdown:hover {
        color: #ffffff;
    }
}

</style>
